var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.854 10.22c0-.648-.053-1.3-.165-1.939h-9v3.675h5.154a4.417 4.417 0 0 1-1.908 2.9v2.384h3.075c1.806-1.662 2.844-4.116 2.844-7.02Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.687 19.543c2.573 0 4.744-.845 6.325-2.304l-3.075-2.385c-.856.583-1.96.912-3.247.912-2.49 0-4.6-1.68-5.358-3.937H2.16v2.457a9.544 9.544 0 0 0 8.527 5.257Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33 11.829a5.716 5.716 0 0 1 0-3.654V5.717H2.16a9.55 9.55 0 0 0 0 8.57l3.17-2.458Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.687 4.235a5.185 5.185 0 0 1 3.66 1.43l2.725-2.724A9.171 9.171 0 0 0 10.687.458a9.54 9.54 0 0 0-8.528 5.26l3.17 2.458c.754-2.262 2.868-3.941 5.358-3.941Z",
    fill: "#EA4335"
  })));
};

export default SvgGoogleIcon;